import React from "react";
import {animated} from "react-spring";
import * as PropTypes from "prop-types";
import copy from "copy-to-clipboard";

export class Contact extends React.Component {
    render() {
        return <section id="contact" className="section-bg">
            <animated.div style={this.props.style} className="container" data-aos="fade-up">

                <div className="section-header">
                    <h2>Contact Us</h2>
                    <p>{this.props.subtitle}</p>
                </div>

                <div className="row contact-info">

                    {/*<div className="col-md-4">*/}
                    {/*    <div className="contact-address">*/}
                    {/*        <i className="ion-ios-location-outline"/>*/}
                    {/*        <h3>Address</h3>*/}
                    {/*        <address>{this.props.address}</address>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    {/*<div className="col-md-4">*/}
                    {/*    <div className="contact-phone">*/}
                    {/*        <i className="ion-ios-telephone-outline"/>*/}
                    {/*        <h3>Phone Number</h3>*/}
                    {/*        <p><a href={this.props.telephoneHref}>{this.props.telephone}</a></p>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <div className="col-md-12">
                        <div className="contact-email">
                            <i className="ion-ios-email-outline"/>
                            <h3>Email</h3>

                            <p> <a href={"/"} onClick={(e)=>{
                                e.preventDefault();
                                copy(this.props.email);
                                alert("Copied "+this.props.email+" to clipboard")
                            }}>{this.props.email}</a></p>
                        </div>
                    </div>

                </div>

                {/*          <div className="form">
                    <form action={"forms/contact.php"} method="post" role="form" className="php-email-form">
                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <input type="text" name="name" className="form-control" id="name"
                                       placeholder="Your Name" data-rule="minlen:4"
                                       data-msg="Please enter at least 4 chars"/>
                                <div className="validate"/>
                            </div>
                            <div className="form-group col-md-6">
                                <input type="email" className="form-control" name="email" id="email"
                                       placeholder="Your Email" data-rule="email"
                                       data-msg="Please enter a valid email"/>
                                <div className="validate"/>
                            </div>
                        </div>
                        <div className="form-group">
                            <input type="text" className="form-control" name="subject" id="subject"
                                   placeholder="Subject" data-rule="minlen:4"
                                   data-msg="Please enter at least 8 chars of subject"/>
                            <div className="validate"/>
                        </div>
                        <div className="form-group">
                                    <textarea className="form-control" name="message" rows="5" data-rule="required"
                                              data-msg="Please write something for us" placeholder="Message"/>
                            <div className="validate"/>
                        </div>
                        <div className="mb-3">
                            <div className="loading">Loading</div>
                            <div className="error-message"/>
                            <div className="sent-message">Your message has been sent. Thank you!</div>
                        </div>
                        <div className="text-center">
                            <button type="submit">Send Message</button>
                        </div>
                    </form>
                </div>*/}

            </animated.div>
        </section>;
    }
}

Contact.propTypes = {
    style: PropTypes.any,
    subtitle: PropTypes.string,
    address: PropTypes.string,
    telephoneHref: PropTypes.string,
    telephone: PropTypes.string,
    email: PropTypes.string
};